module.exports = __webpack_public_path__ + "img/headshot1.3d31041e.png";